// @flow
import React from 'react'
import type { Node } from 'react'
import styled from 'styled-components'

import { myTheme } from '../../../styles'
import EndnoteBacklink from './endnote-backlink'

const { fontSize } = myTheme

type Props = {
  id: string,
  children: Node,
}

const ListItem = styled.li`
  font-size: ${fontSize.six};
  line-height: 1.5;
`
const EndnotesItem = ({ id, children }: Props) => (
  <ListItem id={id}>
    {children} <EndnoteBacklink to={id} />
  </ListItem>
)

export default EndnotesItem



// WEBPACK FOOTER //
// ./src/components/typography/endnotes/endnote-item.js